import { forwardRef } from "react";
import { LoaderCircle } from "lucide-react";
import { cn } from "../lib/cn";

export interface SpinnerProps
  extends React.ComponentPropsWithoutRef<typeof LoaderCircle> {
  size?: number;
  thickness?: number;
  color?: "primary" | "secondary" | "inherit";
}

const colorClasses = {
  primary: "text-content-primary",
  secondary: "text-content-secondary",
  inherit: "",
} as const;

export const Spinner = forwardRef<SVGSVGElement, SpinnerProps>(
  (
    { size = 20, thickness = 2, color = "primary", className, ...props },
    ref,
  ) => (
    <LoaderCircle
      ref={ref}
      size={size}
      strokeWidth={thickness}
      role="img"
      aria-label="Loading"
      className={cn("animate-spin", colorClasses[color], className)}
      {...props}
    />
  ),
);
Spinner.displayName = "Spinner";
